import type { ReactNode } from 'react'
import { Children } from 'react'

export default function (reactNode: ReactNode): string {
  const stringNodes = Children.toArray(reactNode).filter(
    i => typeof i === 'string'
  ) as string[]
  return stringNodes.reduce((acc, cur) => `${acc} ${cur}`.trim(), '')
}
